.comboboxInput {
  --ixf-combobox-input-min-width: 250px;
  --ixf-combobox-icon-height: 1rem;
  --ixf-combobox-icon-width: 1rem;
  --ixf-combobox-input-border-weight: 1px;

  position: relative;
  min-width: var(--ixf-combobox-input-min-width);

  .inputElement {
    border-left: var(--ixf-combobox-input-border-weight) solid
      var(--ixf-input-border-color);
    border-right: var(--ixf-combobox-input-border-weight) solid
      var(--ixf-input-border-color);

    &.lastInputElement {
      border-bottom: var(--ixf-combobox-input-border-weight) solid
        var(--ixf-input-border-color);
      border-bottom-left-radius: var(--ixf-input-border-radius);
      border-bottom-right-radius: var(--ixf-input-border-radius);
    }
  }

  &.flexGrow {
    flex: 1 1 auto;
  }

  &.isDisabled {
    .triggerContainer {
      cursor: default;
    }
  }

  .triggerContainer {
    cursor: pointer;
    width: 100%;
    position: relative;
    border-top: var(--ixf-combobox-input-border-weight) solid
      var(--ixf-input-border-color);
    border-top-left-radius: var(--ixf-input-border-radius);
    border-top-right-radius: var(--ixf-input-border-radius);

    .item {
      flex: 1 1 auto;
      font-size: var(--ixf-input-font-size);
      line-height: var(--ixf-input-line-height);
      font-weight: var(--ixf-input-font-weight);
      height: calc(
        var(--ixf-input-height) - calc(
            var(--ixf-combobox-input-border-weight) * 2
          )
      );
    }

    .triggerSelection {
      flex: 1 1 100%;
    }

    .iconContainer {
      padding-right: var(--ixf-input-padding-horizontal);

      svg path {
        fill: var(--ixf-input-font-color);
      }

      .toggleIcon {
        height: var(--ixf-combobox-icon-height);
        width: var(--ixf-combobox-icon-width);
      }

      .clearButton {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          height: var(--ixf-combobox-icon-height);
          width: var(--ixf-combobox-icon-width);
        }
      }
    }

    .trigger {
      font-size: var(--ixf-input-font-size);
      line-height: var(--ixf-input-line-height);
      font-weight: var(--ixf-input-font-weight);
      align-self: end;
      padding: var(--ixf-input-padding);
      cursor: pointer;
      flex: 1 1 auto;

      &:disabled {
        cursor: default;
      }

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: var(--ixf-input-placeholder-color);
      }
    }
  }

  &.hasValue {
    --ixf-input-padding: calc(
        var(--ixf-input-padding-vertical) + var(--ixf-input-label-active-offset)
      )
      var(--ixf-input-padding-horizontal)
      calc(
        var(--ixf-input-padding-vertical) - var(
            --ixf-input-label-active-offset
          ) +
          var(--ixf-input-label-gap)
      )
      var(--ixf-input-padding-horizontal);
  }
}
